<div class="aging-summary-scf card">
    <div id="aging-summary-scf-card">
        <card i18n-headerTitle headerTitle="Aging Summary" [hasFooter]="false">
            <div card-body class="card-body">
                <ng-container
                    *ngIf="(activeDataSource$ | async | notNull).loading$ | async; else main"
                >
                    <lsq-circle-loader></lsq-circle-loader>
                </ng-container>
                <ng-template #main>
                    <div *ngIf="dataSourcePayLaterOnly" class="tab-controls">
                        <tabs
                            [tabsConfig]="tabsConfig"
                            [shouldUseRouting]="false"
                            (tabClick)="activeTab$.next($event)"
                        ></tabs>
                    </div>
                    <div class="tab-view">
                        <div class="chart-container col-12 col-lg-6">
                            <lsq-chart
                                *ngIf="!(chartIsZero$ | async); else emptyChart"
                                class="doughnut-chart"
                                [options]="chartOptions"
                                [colors]="colors"
                                [labels]="labels"
                                [data]="chartData$ | async | notNull"
                            >
                            </lsq-chart>
                            <div class="chart-center">
                                <div class="number-of-invoices">
                                    {{
                                        ((activeDataSource$ | async | notNull).data$ | async)
                                            ?.invoiceCount | number
                                    }}
                                </div>
                                <div
                                    class="invoices-label"
                                    i18n="invoices count label for doughnut graph"
                                >
                                    {((activeDataSource$ | async | notNull).data$ | async)
                                    ?.invoiceCount | number, plural, =1 {invoice} other {invoices}}
                                </div>
                                <div
                                    *ngIf="(activeDataSource$ | async | notNull).data$ | async"
                                    class="total-dollar-amount"
                                >
                                    {{
                                        ((activeDataSource$ | async | notNull).data$ | async)
                                            ?.openTotalAmount | lsqCurrency
                                    }}
                                </div>
                            </div>
                            <ng-template #emptyChart>
                                <lsq-chart
                                    class="doughnut-chart"
                                    [options]="chartOptions"
                                    [colors]="[blankChartColor]"
                                    [labels]="labels"
                                    [data]="[100]"
                                >
                                </lsq-chart>
                            </ng-template>
                        </div>

                        <div class="chart-legend col-12 col-lg-6">
                            <ul class="chart-legend-list">
                                <li class="chart-legend-item">
                                    <div class="chart-legend-label text-uppercase">
                                        <span>{{ labels[0] }}</span>
                                        <lsq-icon
                                            *ngIf="currentLabelTooltipText$ | async"
                                            class="chart-legend-label-tooltip"
                                            [attr.tabindex]="0"
                                            [type]="icons.QuestionCircleLight"
                                            [popoverOnHover]="true"
                                            [height]="14"
                                            [width]="14"
                                            [popover]="currentLabelTooltipText$ | async | notNull"
                                            [popoverPlacement]="currentLabelTooltipPlacement"
                                            [color]="color.Slate"
                                        >
                                        </lsq-icon>
                                    </div>
                                    <div class="chart-legend-dollar">
                                        {{
                                            ((activeDataSource$ | async | notNull).data$ | async)
                                                ?.openAmountCurrent | lsqCurrency
                                        }}
                                        <div
                                            class="chart-legend-highlight"
                                            [style.background-color]="colors[0]"
                                        ></div>
                                    </div>
                                </li>
                                <li class="chart-legend-item">
                                    <div class="chart-legend-label text-uppercase">
                                        {{ labels[1] }}
                                    </div>
                                    <div class="chart-legend-dollar">
                                        {{
                                            ((activeDataSource$ | async | notNull).data$ | async)
                                                ?.openAmountDayOneToThirty | lsqCurrency
                                        }}
                                        <div
                                            class="chart-legend-highlight"
                                            [style.background-color]="colors[1]"
                                        ></div>
                                    </div>
                                </li>
                                <li class="chart-legend-item">
                                    <div class="chart-legend-label text-uppercase">
                                        {{ labels[2] }}
                                    </div>
                                    <div class="chart-legend-dollar">
                                        {{
                                            ((activeDataSource$ | async | notNull).data$ | async)
                                                ?.openAmountDayThirtyOneToSixty | lsqCurrency
                                        }}
                                        <div
                                            class="chart-legend-highlight"
                                            [style.background-color]="colors[2]"
                                        ></div>
                                    </div>
                                </li>
                                <li class="chart-legend-item">
                                    <div class="chart-legend-label text-uppercase">
                                        {{ labels[3] }}
                                    </div>
                                    <div class="chart-legend-dollar">
                                        {{
                                            ((activeDataSource$ | async | notNull).data$ | async)
                                                ?.openAmountDaySixtyOnePlus | lsqCurrency
                                        }}
                                        <div
                                            class="chart-legend-highlight"
                                            [style.background-color]="colors[3]"
                                        ></div>
                                    </div>
                                </li>
                            </ul>
                            <div class="chart-legend-cta">
                                <lsq-button
                                    [routerLink]="invoicesUrl"
                                    appearance="secondary"
                                    size="md"
                                >
                                    View Invoices
                                </lsq-button>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </card>
    </div>
</div>
